import { render, staticRenderFns } from "./SendSmsWithTemplate.vue?vue&type=template&id=c2b674f0&scoped=true"
import script from "./SendSmsWithTemplate.vue?vue&type=script&lang=js"
export * from "./SendSmsWithTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b674f0",
  null
  
)

export default component.exports